<template>
  <div id="app">
    <Container @onPosition="onPosition" @onChangeMn="onChangeMn" :title="$route.meta.title" v-if="!$route.meta.hideContainer">
      <c-map
        @init="onMapInit"
        ref="map"
        slot="map"
        v-if="show && showMap"
      ></c-map>
      <model
        slot="map"
        @init="onModelInit"
        ref="model"
        v-if="show && !showMap"
      ></model>
      <router-view v-if="show && init"></router-view>
    </Container>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import Container from "@/components/Container.vue";
import Map from "@/components/map/Map.vue";
import Vue from "vue";
import "mapbox-gl/dist/mapbox-gl.css";
import { getToken, getModelToken } from "@/services/services";
import dayjs from "dayjs";
import axios from "axios";
import Model from "@/components/model/Model.vue";
import { queryMe } from "@/services/factory";
import { mapMutations } from "vuex";

export default {
  name: "Dashboard",
  components: { Model, Container, CMap: Map },
  data() {
    return {
      init: false,
      showMap: true,
      show: false,
    };
  },
  methods: {
    ...mapMutations(["SetUnits"]),
    onPosition(id){
      this.$refs.map.onMarkerPosition(id)
    },
    onChangeMn(value){
      this.$refs.map.onChangeMn(value)
    },
    onMapInit() {
      Vue.prototype.$map = this.$refs.map;
      // this.init = false;
      this.init = true;
    },
    onModelInit() {
      Vue.prototype.$model = this.$refs.model;
      // this.init = false;
      this.init = true;
    },
    async render() {
      if (process.env.NODE_ENV === "development") {
        let token = JSON.parse(localStorage.getItem("userToken"));
        if (
          !token ||
          !token.time ||
          (token && dayjs().diff(token.time, "day") >= 1)
        ) {
          let rhenium = await getToken().then(({ login_mfa }) => login_mfa);
          let jxsw = await getModelToken().then(({ login_mfa }) => login_mfa);
          localStorage.setItem(
            "userToken",
            JSON.stringify({
              rhenium: rhenium,
              jxsw: jxsw,
              time: new Date().getTime(),
            })
          );
          this.$router.go(0);
        }
      }
      await queryMe().then(({ units }) => {
        this.SetUnits(units.data);
      });
    },
  },
  mounted() {
    // const aa = ``
    // const arr = aa.split('\n').map(i=>{
    //   const ll = i.split(',')
    //   return {
    //     "name": ll[0],
    //     "caliber": ll[1],
    //     "material": ll[2],
    //     "start_X": ll[3],
    //     "start_Y":ll[4],
    //     "start_Z":ll[5],
    //     "end_X": ll[6],
    //     "end_Y": ll[7],
    //     "end_z": ll[8],
    //     "type":(ll[9]||'').split('\n')[0],
    //     "name2": ll[0].split('.').join(''),
    //
    //   }
    // })

    this.render();
  },
  watch: {
    $route(v) {
      this.show = true;
      this.showMap = v.meta.map;
    },
  },
};
</script>

<style lang="less">
#app,
body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0;
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
  background: #000;
  height: 100%;
  width: 100%;
  font-size: 16px;
}

#app {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  color: #fff;
  user-select: none;
  cursor: url("@/assets/images/pointer.png"), pointer;
  font-family: sans-serif;

  .value {
    font-family: DINCond-Black, sans-serif;
    font-weight: bold;
  }
}

@keyframes slideLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideTop {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.slide-left {
  animation: slideLeft 1s;
}

.slide-right {
  animation: slideRight 1s;
}

.slide-top {
  animation: slideTop 2s;
}

.slide-bottom {
  animation: slideBottom 2s;
}

.sz-dialog {
  background: transparent;
  border: none;
  box-shadow: none !important;

  .el-dialog__header {
    display: none;
  }

  &.el-dialog__wrapper {
    transition-duration: 0.1s;
  }

  &.el-dialog__wrapper.dialog-fade-enter-active,
  &.el-dialog__wrapper.dialog-fade-leave-active {
    animation: none !important;
  }
}
</style>
